var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppartmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.5H13.5V2.5C13.5 2.23478 13.3946 1.98043 13.2071 1.79289C13.0196 1.60536 12.7652 1.5 12.5 1.5H4.5C4.23478 1.5 3.98043 1.60536 3.79289 1.79289C3.60536 1.98043 3.5 2.23478 3.5 2.5V13.5H2C1.86739 13.5 1.74021 13.5527 1.64645 13.6464C1.55268 13.7402 1.5 13.8674 1.5 14C1.5 14.1326 1.55268 14.2598 1.64645 14.3536C1.74021 14.4473 1.86739 14.5 2 14.5H15C15.1326 14.5 15.2598 14.4473 15.3536 14.3536C15.4473 14.2598 15.5 14.1326 15.5 14C15.5 13.8674 15.4473 13.7402 15.3536 13.6464C15.2598 13.5527 15.1326 13.5 15 13.5ZM4.5 2.5H12.5V13.5H4.5V2.5ZM11 8.25C11 8.39834 10.956 8.54334 10.8736 8.66668C10.7912 8.79001 10.6741 8.88614 10.537 8.94291C10.4 8.99967 10.2492 9.01453 10.1037 8.98559C9.9582 8.95665 9.82456 8.88522 9.71967 8.78033C9.61478 8.67544 9.54335 8.5418 9.51441 8.39632C9.48547 8.25083 9.50033 8.10003 9.55709 7.96299C9.61386 7.82594 9.70999 7.70881 9.83332 7.6264C9.95666 7.54399 10.1017 7.5 10.25 7.5C10.4489 7.5 10.6397 7.57902 10.7803 7.71967C10.921 7.86032 11 8.05109 11 8.25Z",
    fill: "#313441"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppartmentIcon);
export default __webpack_public_path__ + "static/media/appartment-icon.743f7e6643bc2d4c4668f49ea58ba139.svg";
export { ForwardRef as ReactComponent };